import { FC } from "react";
import { IconProps } from "./types";

export const CaretUpLine: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.06 17.06a1.5 1.5 0 0 0 0-2.12l-8-8a1.5 1.5 0 0 0-2.12 0l-8 8a1.5 1.5 0 0 0 2.12 2.12L12 10.122l6.94 6.94a1.5 1.5 0 0 0 2.12 0z"
      fill={fill}
    />
  </svg>
);
